module.exports = __webpack_public_path__ + "assets/1.01949489.svg";